import { render, staticRenderFns } from "./domainOp.vue?vue&type=template&id=28355826&lang=pug"
import script from "./domainOp.vue?vue&type=script&lang=js"
export * from "./domainOp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports